import BursonEventPendingAlertHtml from './templates/legacy.burson.event-pending.alert.html';
import BursonRequestEventHtml      from './legacy.burson.request-event.html';

export function LegacyBursonEventsService (
  $uibModal,
  $q,
  $translate,
  confirm,
  sessionObjAPI,
  workshopAPI
) {
  const LegacyBursonEvents = function () {
    this.origin  = sessionObjAPI.base().origin;
  };

  LegacyBursonEvents.prototype.addItems = function (event) {
    const self = this;

    if (event.current_bursons_order) {
      return self.checkBursonAvailability(event)
      .then(() => self.createBursonOrder(event))
      .catch(() => self.eventPendingAlert(event));
    }

    return self.createBursonOrder(event);
  };

  LegacyBursonEvents.prototype.checkBursonAvailability = function (event) {
    return workshopAPI.get('/bursons/check_bursons_id_for_event', event.id)
    .then(requestId => {
      return requestId === '0' ? $q.reject($translate.instant('JS_SPACE.BURSON.ORDER_NOT_COMPLETED')) : $q.when(event);
    });
  };

  LegacyBursonEvents.prototype.createBursonOrder = function (event) {
    return workshopAPI.get('/bursons/create_burson_order_for_event', event.id)
    .then(data => {
      return data.order.RequestStatus != 'FAIL' ?
        workshopAPI.get('/bursons/add_burson_request_id_to_event', [ data.order.RequestID, event.id ]) :
        $q.reject(data.order.RequestStatus + " - " + data.order.ErrorReason);
    }).then(event => {
      return $uibModal.open({
        templateUrl: BursonRequestEventHtml,
        controller : 'LegacyBursonRequestEventCtrl',
        windowClass: 'lg-modal',
        resolve    : {
          event () {
            return event;
          },
          customer () {
            return workshopAPI.get('/customer', event.customer_id);
          }
        }
      }).result;
    });
  };

  LegacyBursonEvents.prototype.getBursonItems = function (event) {
    const self = this;

    return self.checkBursonAvailability(event)
    .then(event => workshopAPI.get('/bursons/get_single_burson_order_for_event', [event.current_bursons_order, event.id]))
    .then(items => workshopAPI.post('/bursons/add_bursons_items_to_event', items, 'items'))
    .then(data => workshopAPI.get('/bursons/remove_burson_request_id_from_event', data))
    .then(() => $q.when($translate.instant('JS_SPACE.BURSON.BURSON_PARTS_ADDED')));
  };

  LegacyBursonEvents.prototype.eventPendingAlert = function (event) {
    return $uibModal.open({
      templateUrl: BursonEventPendingAlertHtml,
      controller : 'LegacyBursonRequestEventCtrl',
      windowClass: 'lg-modal',
      resolve    : {
        event () {
          return event;
        },
        customer () {
          return workshopAPI.get('/customer', event.customer_id);
        }
      }
    }).result;
  };

  LegacyBursonEvents.prototype.overwrite = function (event) {
    return workshopAPI.get('/bursons/remove_burson_request_id_from_event', event.id)
    .then(data => workshopAPI.get('/bursons/create_burson_order_for_event', data.id))
    .then(data => workshopAPI.get('/bursons/add_burson_request_id_to_event', [ data.order.RequestID, event.id ]))
    .then(event => {
      return $uibModal.open({
        templateUrl: BursonRequestEventHtml,
        controller : 'LegacyBursonRequestEventCtrl',
        windowClass: 'lg-modal',
        resolve    : {
          event () {
            return event;
          },
          customer () {
            return workshopAPI.get('/customer', event.customer_id);
          }
        }
      }).result;
    });
  };

  return LegacyBursonEvents;
}
